// extracted by mini-css-extract-plugin
export default {"container":"_2euh2","inPostPage":"_2aryt","noMargin":"_3rJhG"};